import React, { useState, useEffect } from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Stack,
  IconButton,
  Menu,
  MenuItem,
  Button,
} from "@mui/material";
import { Avatar } from "primereact/avatar";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { useNavigate } from "react-router-dom"; // if you use react-router for navigation
import "./Header.css";
import logo from "../assests/LogoAays1.png";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../auth/authConfig";
import marsIcon from "../assests/snackingRingLogo.png"

import Tooltip from '@mui/material/Tooltip';
import axios from "axios";
import UserGuideMenu from "../component/common/UserGuideMenu";
import { useAuth } from "../context/AuthContext";

const Header = () => {
  const { authUser } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null); // anchor element for menu
  const [userRole, setUserRole] = useState("");
  const open = Boolean(anchorEl);
  const { accounts, instance } = useMsal();
  const account = accounts?.[0];
  const name = account?.name || "User";
  const email = account?.username || "user@effem.com";
  const [photo, setPhoto] = useState(null);


  console.log("Account Details:", account);

  const getProfilePhoto = async () => {
    try {
      // Ensure you acquire a token for the signed-in user
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0], // Use the first account from the authenticated accounts
      });

      const token = response.accessToken;

      // Fetch the profile photo
      const photoResponse = await axios.get(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
          },
          responseType: "arraybuffer", // To receive the image as binary data
        }
      );

      const blob = new Blob([photoResponse.data], { type: "image/jpeg" });
      const imageUrl = URL.createObjectURL(blob);
      setPhoto(imageUrl);
      if(imageUrl){
        localStorage.setItem("profilePhoto", imageUrl);
      }
     
    } catch (err) {
      console.error("Error fetching profile photo", err);
    }
  };


  useEffect(() => {
    getProfilePhoto();
  }, []);
  
  useEffect(() => {
    if (authUser?.role) {
      setUserRole(authUser.role);
    }
  }, [authUser]);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // Your logout logic here
    console.log("Logout clicked");
    handleClose();
  };

  return (
    <AppBar
      position="static"
      className="main-header"
      sx={{
        backgroundColor: "#bb1ccc",
        height: "92px",
        justifyContent: "center",
        background: "linear-gradient(90deg, #fff 0%, #fff 100%)",
        borderBottom: '1px solid #eee',
        outline: 'none',
        boxShadow: 'none'

      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", }}>
        {/* Logo */}
        <Box sx={{ px: 2, py: 1, display: "flex", gap: "20px", justifyContent: "flex-start", alignItems: "center"}}>
          <img src={logo} alt="logo" width={90} />
        </Box>

        <Box sx={{display: "flex", gap:"20px", alignItems: "center"}}>
          <div className="flex items-center gap-4 pr-4">
            <UserGuideMenu />
          </div>

          <div
            style={{
              height: "20px",
              borderLeft: "1px solid #bb1ccc",
              borderRight: "1px solid #bb1ccc",
              paddingLeft: "20px",
              paddingRight: "20px",
              display: "flex",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <Tooltip
              title="Opens the production Feature Requests with a redirect notice"
              placement="bottom"
            >
              <Typography
                role="button"
                onClick={() => navigate("/feature-requests")}
                sx={{
                  color: "#bb1ccc",
                  fontSize: "14px",
                  fontWeight: "400",
                  textDecoration: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.75,
                  "&:hover": { textDecoration: "underline" },
                  cursor: "pointer",
                  fontFamily: "Poppins",
                }}
              >
                <AssignmentTurnedInIcon
                  sx={{ fontSize: "20x", color: "#bb1ccc" }}
                />
                <span>Leave feedback</span>
              </Typography>
            </Tooltip>

         
          </div>

          <div className="flex items-center gap-2">


            <Avatar
            image={photo ? photo : null}
            data-pr-tooltip={name || "User"}
            style={{
              verticalAlign: "top",
              position: "relative",
              backgroundColor: "#bb1ccc",
              color: "white",
              fontWeight: "bold",
              height: "35px",
              width: "35px",
              cursor: "pointer",
            }}
            onClick={handleAvatarClick}
            shape="circle"
          >
            {photo ? "" : name?.charAt(0).toUpperCase() || 'U'}
          </Avatar>
          <p className="text-[#bb1ccc] font-poppins font-normal" >{name ? name : ""}</p>

            </div>
          </Box>

    
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <MenuItem>
              {name}
            </MenuItem>
            {userRole === "Admin" && (
              <MenuItem
                onClick={() => {
                  navigate("/accessManagement");
                  handleClose();
                }}
              >
                Access Management
              </MenuItem>
            )}
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
            <MenuItem>
              <span style={{ overflowWrap: "anywhere" }}>
                {email}
              </span>
            </MenuItem>
          </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
